import Loadable from "../../components/Loadable";
import { lazy } from "react";
import { PAYROLL } from "../../utils/constant";

const PayrollDashboard = Loadable(lazy(() => import("./PayrollDashboard")));
const SalaryStructure = Loadable(lazy(() => import("./SalaryStructure")));

const payrollRoutes = [
  {
    path: "/payroll/dashboard",
    element: <PayrollDashboard />,
    permission: PAYROLL,
  },
  {
    path: "/payroll/salary-structure",
    element: <SalaryStructure />,
    permission: PAYROLL,
  },
];

export default payrollRoutes;